/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Features_Messages_UnlimitedInputs */

const es_components_upgrade_plan_modal_features_messages_unlimited = /** @type {(inputs: Components_Upgrade_Plan_Modal_Features_Messages_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensajes ilimitados por mes`)
};

const en_components_upgrade_plan_modal_features_messages_unlimited = /** @type {(inputs: Components_Upgrade_Plan_Modal_Features_Messages_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited messages per month`)
};

/**
* | output |
* | --- |
* | "Unlimited messages per month" |
*
* @param {Components_Upgrade_Plan_Modal_Features_Messages_UnlimitedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_features_messages_unlimited = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Features_Messages_UnlimitedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Features_Messages_UnlimitedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_features_messages_unlimited(inputs)
	return en_components_upgrade_plan_modal_features_messages_unlimited(inputs)
});
export { components_upgrade_plan_modal_features_messages_unlimited as "components.upgrade_plan_modal.features.messages_unlimited" }